global.CXEBLOCKTYPE = {
    END: 0,
    INSTRUCTIONS: 1,
    STRINGS: 2,
    LUADATA: 3,
};

global.CXEINSTYPE = {
    NOP: 0,
    CLOSE: 1,
    JUMP: 2,
    JUMPIF: 3,
    SETMESSAGE: 4,
    SETOPTION: 5,
    CLEAROPTIONS: 6,
    OPTCONDITION: 7,
    LUACONDITION: 8,
    QSDCONDITION: 9,
    LUAACTION: 10,
    QSDACTION: 11,
};

global.CXECURREQ = {
    ERROR: 0,
    CLOSE: 1,
    OPTCONDITION: 2,
    LUACONDITION: 3,
    LUAACTION: 4,
    QSDCONDITION: 5,
    QSDACTION: 6,
};

export const CON_COMMAND = {
    CLOSE: 0,
    NEXT_MESSAGE: 1,
    NPC_SAY: 2,
    PLAYER_SELECT: 3,
    JUMP_SELECT: 4,
} as const;

export interface ConEntry {
    id: number;
    command: number;
    commandName: string;
    data: number;
    conditionFunction: string;
    rewardFunction: string;
    stringId: number;
}

export interface ConDialogBlock {
    size: number;
    entries: ConEntry[];
}

export interface ConSourceMetadata {
    formatVersion: number;
    sourceCon: string;
    sourceConSha256: string;
    sourceLuaChunkSha256: string;
    reviewStatus: string;
    controlFlowReviewRequired: boolean;
    missingFunctionReferences: string[];
    missingEnglishStringIds: number[];
}

export function conversationAssetName(sourcePath: string): string {
    const normalized = String(sourcePath).replace(/\\/g, "/");
    const fileName = normalized.split("/").pop()!.split(/[?#]/, 1)[0];
    const baseName = fileName.replace(/\.[^.]+$/, "").toUpperCase();
    if (!/^[A-Z0-9-]+$/.test(baseName)) {
        throw new Error(`Invalid conversation source path: ${sourcePath}`);
    }
    return baseName;
}

async function fetchConversationFile(url: string): Promise<Response> {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(
            `Could not load editable conversation asset ${url} (${response.status})`,
        );
    }
    return response;
}

export class NpcChatDataOld {
    eventMask = 0;
    loadFunctions: string[] = [];
    instructions: any[] = [];
    strings: any = { en: {} };
    luaData = "";
    luaDataIsBytecode = false;
    initEntries: ConEntry[] = [];
    dialogBlocks: ConDialogBlock[] = [];
    formatVersion = 0;
    sourceCon = "";
    sourceConSha256 = "";
    sourceLuaChunkSha256 = "";
    reviewStatus = "";
    controlFlowReviewRequired = false;
    missingFunctionReferences: string[] = [];
    missingEnglishStringIds: number[] = [];

    static async loadSource(path: string): Promise<NpcChatDataOld> {
        const assetName = conversationAssetName(path);
        const assetRoot = `/conversations/${encodeURIComponent(assetName)}`;
        const [dialogResponse, luaResponse] = await Promise.all([
            fetchConversationFile(`${assetRoot}.json`),
            fetchConversationFile(`${assetRoot}.lua`),
        ]);
        const dialog = await dialogResponse.json();
        const luaSource = await luaResponse.text();

        if (dialog.formatVersion !== 1 || !Array.isArray(dialog.dialogBlocks)) {
            throw new Error(`${assetName}.json is not a supported conversation source`);
        }

        const data = Object.assign(new NpcChatDataOld(), dialog);
        data.luaData = luaSource;
        data.luaDataIsBytecode = false;
        data.strings = dialog.strings || { en: {} };
        for (const block of data.dialogBlocks) {
            for (const entry of block.entries) {
                if (entry.stringId > 0 && !data.strings.en[entry.stringId]) {
                    data.strings.en[entry.stringId] = `[String ID: ${entry.stringId}]`;
                }
            }
        }
        return data;
    }

    static load(path: string, callback: (data: NpcChatDataOld) => void): void {
        NpcChatDataOld.loadSource(path)
            .then(callback)
            .catch((error) => {
                console.error(`Failed to load source conversation for ${path}`, error);
            });
    }
}
